import { Dialog } from "primereact/dialog"
import { ControleType, PlanoType, PlantioType } from "../../db/Orm"
import { useEffect, useRef, useState } from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Card } from "primereact/card"
import { Button } from "primereact/button"
import { ConfirmDialog } from "primereact/confirmdialog"
import { Toast } from "primereact/toast"
import API from "../../api/API"

type VisualizacaoControlesProps = {
    visible: boolean
    hide: ()=>void
    antecipacao: PlanoType
    carregarPlanos: ()=>Promise<void>|(()=>void)
}
const templateIrrigacao = (plantio?:PlantioType)=>{
    if (!plantio) return ''
    if (!plantio.irrigacao_fluvial && !plantio.irrigacao_poco) return 'NENHUM'
    if (plantio.irrigacao_fluvial && !plantio.irrigacao_poco) return 'FLUVIAL'
    if (!plantio.irrigacao_fluvial && plantio.irrigacao_poco) return 'POÇO'
    return 'FLUVIAL E POÇO'
}
const templateTipos = (controle: ControleType)=>{
    if (!controle.tipo) return ''
    return controle.tipo === 'D' ? 'DOENÇA' : 'PRAGA'
}
export const VisualizacaoControles = (props: VisualizacaoControlesProps)=>{
    const [controlesData, setControlesData] = useState<ControleType[]>([])
    const [selectedControle, setSelectedControle] = useState<ControleType|null>(null)
    const controlePlantioMap = useRef<Map<ControleType, PlantioType>>(new Map())
    useEffect(()=>{
        const plantios = props.antecipacao.plantios
        if (!plantios) return
        const conData:ControleType[] = []
        plantios.forEach((pl)=>{
            if (!pl.controles) return
            pl.controles.forEach((con)=>{
                conData.push(con)
                controlePlantioMap.current.set(con, pl)
            })
        })
        setControlesData(conData)
    }, [props.antecipacao.plantios])
    const toastRef = useRef<Toast>(null)
    const [confirmVisible, setConfirmVisible] = useState<boolean>(false)
    const confirmarExclusaoControle = ()=>{
        console.log('Excluindo controle', selectedControle)
        const controleId = selectedControle?.id
        if (typeof(controleId) !== 'number'){
            console.error('Erro ao excluir controle. Id de controle inválido')
            toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: 'Id de controle inválido' })
            return 
        }
        API.removeControle(controleId).then((resp)=>{
            if (resp instanceof Error){
                console.error('Erro ao excluir controle', resp)
                toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao excluir controle' })
            } else {
                toastRef.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Controle excluído com sucesso' })
                props.carregarPlanos()
            }
            setConfirmVisible(false)
        })
    }
    return <Dialog visible={props.visible} onHide={props.hide} header='Visualização de Controles'
        style={{ width: 'max(480px, min(1140px, 100%, 100dvw))' }} >
        <Toast ref={toastRef} position="center" />
        <ConfirmDialog visible={confirmVisible} onHide={()=>setConfirmVisible(false)} header="EXCLUIR CONTROLE" message="Deseja excluir este controle?"
            accept={confirmarExclusaoControle} />
        <h4>PLANTIOS</h4>
        <DataTable value={props.antecipacao.plantios||[]}>
            <Column field='id' header='ID' />
            <Column field='data' header='Data do Plantio' />
            <Column field='cultura' header='Cultura' />
            <Column header='Quantidade de Controles Associados' body={(v)=>v.controles?.length || 'Nenhum controle cadastrado'} />
        </DataTable>
        <h4>CONTROLES CADASTRADOS</h4>
        <DataTable value={controlesData} dataKey='id' selectionMode='single' selection={selectedControle}
            onSelectionChange={(e)=>{setSelectedControle(e.value as ControleType)}} >
            <Column field='plantio' header='ID do plantio' />
            <Column field='tipo' header='Tipo' body={templateTipos} />
            <Column field='nome' header='Nome' />
            <Column field='produto' header='Produto' />
            <Column field='fabricante' header='Fabricante' />
            <Column field='aplicacao' header='Aplicação' />
            <Column field='dose' header='Dose' />
            <Column field='epoca' header='Época' />
        </DataTable>
        {selectedControle && <Card title='Dados do Plantio' >
            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                <table>
                    <tr>
                        <th>Data do Plantio</th>
                        <td>{controlePlantioMap.current.get(selectedControle)?.data?.toString()}</td>
                    </tr>
                    <tr>
                        <th>Cultura</th>
                        <td>{controlePlantioMap.current.get(selectedControle)?.cultura}</td>
                    </tr>
                    <tr>
                        <th>Variedade</th>
                        <td>{controlePlantioMap.current.get(selectedControle)?.variedade}</td>
                    </tr>
                    <tr>
                        <th>Produtividade</th>
                        <td>{controlePlantioMap.current.get(selectedControle)?.produtividade}</td>  
                    </tr>
                    <tr>
                        <th>Irrigação</th>
                        <td>{templateIrrigacao(controlePlantioMap.current.get(selectedControle))}</td>
                    </tr>
                    <tr>
                        <th>Número de Lotes</th>
                        <td>{controlePlantioMap.current.get(selectedControle)?.lotes?.length || '0'}</td>
                    </tr>
                </table>
                <Button label='Excluir Controle' severity='danger' style={{ height: '3em', alignSelf:'end' }}
                    onClick={()=>setConfirmVisible(true)} />
            </div>
        </Card>}
    </Dialog>
}